import { CampaignApiError } from './campaign-api-error';

export class CampaignEditorialError extends CampaignApiError {
  constructor(message, property, code, disapprovedText, isAppealable, isHtmlMessage = false) {
    super(message, property, code);

    this.disapprovedText = disapprovedText;
    this.isAppealable = isAppealable;
    this.isHtmlMessage = isHtmlMessage;
  }
}
